import { gql } from 'apollo-angular';

export const REQUEST_LOGIN_OTP = gql`
    mutation RequestLoginOtp($phoneNumber: String!) {
        requestLoginOtp(phoneNumber: $phoneNumber) {
            success
            message
            expiresAt
        }
    }
`;

export const VERIFY_LOGIN_OTP = gql`
    mutation VerifyLoginOtp($phoneNumber: String!, $otp: String!) {
        verifyLoginOtp(phoneNumber: $phoneNumber, otp: $otp) {
            success
            requiresRegistration
            message
        }
    }
`;

export const AUTHENTICATE_SMS_OTP = gql`
    mutation AuthenticateSmsOtp($phoneNumber: String!) {
        authenticate(input: { smsOtp: { phoneNumber: $phoneNumber } }) {
            ...on CurrentUser {
                id
            }
            ...on InvalidCredentialsError {
                errorCode
                message
            }
        }
    }
`;
